// extracted by mini-css-extract-plugin
module.exports = {"color-1":"#3983ff","color-2":"#ff7045","color-3":"#8963df","color-4":"#00debc","color-5":"#fa2471"};